import { accordion, addresses, gallery, realizations, team, blog, textImage, text, keyFigures, button, factory, contact, resources, realizationIntoduction, realization, listRealizations, customers } from '@js/modules/blocks'
import store from '@js/modules/store'

export default class GlobalRenderer {
    onEnter(page) {
        // Disable asscroll
        if(window.innerWidth >= 1024)
            store.asscroll.disable()
    }
    onEnterCompleted(page) {
        // Animations
	    if(window.innerWidth >= 1024) {
            // Top appearance
            new Promise(resolve => {
                store.animizi.addTopImage(page.querySelector('.o-top_background'), resolve)
            }).then(() => {
                // Top parallax
                store.animizi.addTopParallax(page.querySelector('.o-top_background'))

                // Enable asscroll
                if(window.innerWidth >= 1024) {
                    store.asscroll.enable({
                        newScrollElements: [
                            page,
                            store.footer
                        ],
                        reset: true
                    })
                }
            })
        }

        // Iterate over global blocks and init them
        const blocks = page.querySelectorAll('.o-block[data-type]')
        blocks.forEach(block => {
            switch (block.dataset.type) {
                case 'addresses':
                    addresses(block)
                    break
                case 'accordion':
                    accordion(block)
                    break
                case 'gallery':
                    gallery(block)
                    break
                case 'realizations':
                    realizations(block)
                    break
                case 'team':
                    team(block)
                    break
                case 'blog':
                    blog(block)
                    break
                case 'textImage':
                    textImage(block)
                    break
                case 'text':
                    text(block)
                    break
                case 'keyFigures':
                    keyFigures(block)
                    break
                case 'button':
                    button(block)
                    break
                case 'factory':
                    factory(block)
                    break
                // case 'contact':
                //     contact(block)
                //     break
                case 'addresses':
                    addresses(block)
                    break
                case 'resources':
                    resources(block)
                    break
                case 'realizationIntoduction':
                    realizationIntoduction(block)
                    break
                case 'realization':
                    realization(block)
                    break
                case 'listRealizations':
                    listRealizations(block)
                    break
                case 'customers':
                    customers(block)
                    break
            }
        })
    }
    onLeave() {
        // Disable asscroll
        if(window.innerWidth >= 1024)
            store.asscroll.disable()

        // Clean tweens
        if(store.animizi)
            store.animizi.clean()
    }
    onLeaveCompleted() {
        // Enable asscroll
        if(window.innerWidth >= 1024) {
            store.asscroll.enable()
            store.asscroll.currentPos = 0
        }
    }
}
